import { Typography } from '@mui/material';
import formatString from '@utils/formatString';
import ReactECharts from 'echarts-for-react';
import { forwardRef, useEffect, useState } from 'react';

const TreeMapChart = forwardRef(
  (
    {
      themes,
      categories,
      selectedTheme,
      selectedCategory,
      isShowInterpretation = true,
      onChartClick,
      getColorByCategory,
    },
    ref,
  ) => {
    const [error] = useState(null);
    const [option, setOption] = useState({});

    useEffect(() => {
      setOption({
        series: [
          {
            type: 'treemap',
            data: themes?.map((theme) => {
              // Safely handle color - default to a gray if not provided
              const color = theme?.color || 'hsl(0, 0%, 70%)';
              const alphaColor = color.replace('hsl', 'hsla').replace(')', ', 0.3)');
              return {
                name: `${formatString(theme?.name || '')}: (n = ${theme?.saliency})`,
                value: theme?.saliency,
                originalName: theme?.name,
                itemStyle: { color: alphaColor },
                treeType: theme?.type,
              };
            }),
            width: '100%',
            height: '100%',
            label: {
              show: true,
              position: 'inside',
              formatter: '{b}',
              color: '#333333',
              fontSize: '1rem',
            },
            roam: 'move',
            nodeClick: 'true',
            breadcrumb: { show: false },
            animation: true,
            animationDuration: 800,
            animationEasing: 'cubicOut',
            animationDurationUpdate: 800,
            animationEasingUpdate: 'cubicOut',
          },
        ],
        tooltip: {
          trigger: 'item',
          formatter: function (info) {
            const { originalName, value } = info.data;
            return `<strong>${originalName}</strong><br/>Saliency: ${value}`;
          },
        },
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
      });
    }, [themes, categories, selectedTheme, selectedCategory, getColorByCategory]);

    const onEvents = {
      click: onChartClick,
    };

    return (
      <>
        {error ? (
          <Typography variant="body2" color="error" mt={2}>
            {error}
          </Typography>
        ) : (
          <ReactECharts
            ref={ref}
            option={option}
            onEvents={onEvents}
            style={{ height: '100%', width: '100%' }}
          />
        )}

        {isShowInterpretation && (
          <Typography variant="body2" mt={2}>
            <strong>How to interpret the Tree Map:</strong> Each block represents a theme or
            category based on the selected level. The size of each block is proportional to its
            saliency value, and hovering over a block reveals additional details. Themes appear at
            the top level unless a specific theme or category is selected.
          </Typography>
        )}
      </>
    );
  },
);

TreeMapChart.displayName = 'Tree Map Chart';

export default TreeMapChart;
